import type { Font } from 'opentype.js';
import { checkContent } from '@/core/content/check';
import type { ContentCheck } from '@/core/content/types';
import { buildScene } from '@/core/layout/build';
import type { Project } from '@/core/project/types';
import { encodeQr, type EncodeResult } from '@/core/qr/encode';
import type { Scene } from '@/core/render/scene';

/**
 * Полный путь от проекта до сцены.
 *
 * Функция чистая и синхронная, поэтому её вызывает и предпросмотр (с
 * небольшой задержкой), и экспорт (сразу, по последнему подтверждённому
 * состоянию). Из-за этого файл не может оказаться собранным по устаревшим
 * настройкам, пока предпросмотр догоняет ввод.
 */
export type Composition = {
  content: ContentCheck;
  encoded: EncodeResult;
  scene: Scene | null;
};

export function compose(project: Project, font: Font | null): Composition {
  const content = checkContent(project.payload);
  if (!content.ok) return { content, encoded: { status: 'empty' }, scene: null };

  const encoded = encodeQr(content.encoded, project.qr.errorCorrection);
  if (encoded.status !== 'ok') return { content, encoded, scene: null };

  return { content, encoded, scene: buildScene({ project, matrix: encoded.matrix, font }) };
}
